import { useState, useEffect, useRef } from "react";

export const useImageLoader = (imageUrl?: string) => {
  const imgRef = useRef<HTMLImageElement | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!imageUrl) {
      return;
    }

    imgRef.current = new Image();
    imgRef.current.src = imageUrl;

    const handleLoad = () => {
      setIsLoading(false);
    };

    const handleError = () => {
      setIsLoading(false);
      console.error("Error loading image:", imageUrl);
    };

    imgRef.current.addEventListener("load", handleLoad);
    imgRef.current.addEventListener("error", handleError);

    return () => {
      imgRef.current?.removeEventListener("load", handleLoad);
      imgRef.current?.removeEventListener("error", handleError);
    };
  }, [imageUrl]);

  return { isLoading };
};
